<script>
export default {
  props: {
    productId: Number,
  },
  methods: {
    getClients: function () {
      axios.get(Scoop.baseUrl + '/newCategoriesOfProduct?productId=' + this.productId).then(response => {
        this.clientsMutable = response.data.clients;
      });
    }
  },
  mounted: function () {
    this.getClients();
  },
  data() {
    return {
      clientsMutable: [],
    }
  },
}
</script>

<template>
  <div class="row m-b-md">
    <span v-if="clientsMutable.length > 0" class="font-bold">Neu in: </span>
    <span v-for="client in clientsMutable" class="badge badge-primary m-l-xs" v-text="client"></span>
  </div>
</template>
